export const basename = "pre-assessment-service";
//  export const apiDomain = "https://bluecross.hashtechpro.com"; export const gtmId = ''; export const isProduction = false;  // HT_DEV
//export const apiDomain = "https://aiabx-d-bxcfss.aiaazure.biz"; export const gtmId = ''; export const isProduction = false;  // BX_DEV
// export const apiDomain = "https://wt06.bluecross.com.hk"; export const gtmId = 'GTM-WQHT9D'; export const isProduction = false;  // BX_UAT
//export const apiDomain = "https://aiabx-u-bxaweb.aiaazure.biz"; export const gtmId = ''; export const isProduction = false;  // BX_INTRANET_UAT
// export const apiDomain = "https://www.bluecross.com.hk"; export const gtmId = 'GTM-MWNX75'; export const isProduction = true;  // BX_PROD
// export const apiDomain = "https://www.bluecross.com.hk"; export const gtmId = ''; export const isProduction = true;  // BX_INTRANET_PROD
export const apiDomain =process.env.REACT_APP_ENV_APIDOMAIN || window.location.origin; export const gtmId = process.env.REACT_APP_ENV_GTMID; export const isProduction = process.env.REACT_APP_ENV_ISPRODUCTION;;  // BX_UAT
export const enableInternetPath = true; // enableInternetPath
export const enableIntranetPath = true; // enableIntranetPath

/**
 * 调查问卷公用服务接口地址
 */
export const csatAPiDomain = process.env.REACT_APP_csatAPiDomain  
// "https://wt01.bluecross.com.hk/csatservice/api"; // DEV or uat
// export const csatAPiDomain = "https://ap.bluecross.com.hk/csatservice/api"; // DEV or uat

